<template>
  <el-upload
    action=""
    class="avatar-uploader"
    :style="`width:${size};height:${size};`"
    :show-file-list="false"
    :on-change="handleFileChange"
    :http-request="uploadFile"
    :on-success="handleAvatarSuccess"
    :before-upload="beforeAvatarUpload"
  >
    <template v-if="loading">
      <el-progress :show-text="false" :stroke-width="1" :percentage="process" color="#3a416f"></el-progress>
    </template>

    <template v-else>
      <el-image v-if="url" :src="url" class="avatar" fit="contain"></el-image>
      <span class="up-icon" v-else>+</span>
    </template>
  </el-upload>
</template>
<script>
import { uploadFileDirect } from '@/server/common'
export default {
  name: 'picture-upload',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      default: ''
    },
    size: {
      default: '80px'
    },
    folder: {
      default: 'default'
    },
    beforeUpload: {
      default: undefined
    }
  },
  watch: {
    value: {
      handler: function(val) {
        this.url = val
      },
      immediate: true
    }
  },
  data() {
    return {
      loading: false,
      timmer: null,
      url: '',
      process: 0,
      file: undefined
    }
  },
  mounted() {},

  methods: {
    handleFileChange(file) {
      this.file = file.raw
    },
    handleAvatarSuccess(res, file) {
      //  this.$emit('change', URL.createObjectURL(file.raw))
      // this.params.img = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {
      if (this.beforeUpload) {
        return this.beforeUpload(file)
      }
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg'
      const isPng = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!(isJPG || isPng)) {
        this.$message.error(this.$t('stores::products-info::upload-type-tips'))
      }
      if (!isLt2M) {
        this.$message.error(this.$t('stores::products-info::upload-size-tips'))
      }
      return (isJPG || isPng) && isLt2M
    },
    beforeDestroy() {
      if (this.timmer) {
        clearInterval(this.timmer)
        this.timmer = null
      }
    },
    processInt(bool) {
      this.process = 0
      const ddom = Math.random(5, 10) * 10 + 5
      this.timmer = setInterval(() => {
        const rdom = Math.random(0, 10) * 10
        this.process += parseInt(rdom)
        if (bool) {
          if (this.process >= 90) {
            this.process = 90 + ddom
          }
        } else {
          this.process = 100
          clearInterval(this.timmer)
        }
        if (this.process > 100) {
          this.process = 100
          clearInterval(this.timmer)
        }
      }, 100)
    },
    async uploadFile() {
      this.loading = true
      this.processInt(this.loading)
      const { data } = await uploadFileDirect(this.file, this.folder)
      setTimeout(() => {
        this.loading = false
      }, 1000)
      if (data.code === this.$code) {
        this.$emit('change', data.data.absolutePath)
        this.$emit('on-success', data.data.absolutePath)
      } else {
        this.$message.error(data.msg)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.avatar-uploader {
  ::v-deep {
    .el-upload {
      box-sizing: border-box;
      padding: 4px;
      width: 100%;
      height: 100%;
      margin-right: 8px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      color: #3a416f;
      .up-icon {
        display: flex;
        align-items: center;
        flex-direction: column;
        font-size: 30px;
      }
      .el-progress {
        width: 100%;
        .el-progress-bar__outer {
          background-color: #f1f1f1;
        }
      }
    }
  }
  .avatar {
    width: 100%;
    height: 100%;
    display: block;
  }
}
</style>
